import { useEffect, useState } from 'react';

import { getInjector } from '@/services/angularjs-bridge';

const useOrganisationService = () => {
    // eslint-disable-next-line
    const [organisationService, setOrganisationService] = useState<any>();
    useEffect(() => {
        const angularJSInjector = getInjector();
        const organisationService = angularJSInjector.get('OrganizationService');
        setOrganisationService(organisationService);
    }, []);
    return { organisationService };
};

export default useOrganisationService;
